export class Helpers {
    public static copyObject<T>(object: T): T {
        if (object == undefined || object == null) return object;

        var objectCopy: any = {};
        //var objectCopy: Object = {};

        if (object['__proto__']) {
            objectCopy = Object.create(object['__proto__']);
            objectCopy.constructor.apply(objectCopy, null);
        }

        for (var key in object) {
            if (object.hasOwnProperty(key)) {
                if (typeof object[key] === 'object') {
                    objectCopy[key] = Helpers.copyObject(object[key]);
                } else {
                    objectCopy[key] = object[key];
                }
            }
        }

        return <T>objectCopy;
    }

    public static deleteFromArray(arr: any[], item: any) {
        const index = arr.findIndex((x) => x == item);
        if (index > -1) {
            arr.splice(index, 1);
        }
    }

    public static GetTicks() {
        var d = new Date();
        return d.getTime();
    }

    public static GetGUID() {
        let d = new Date().getTime(); //Timestamp
        let d2 =
            (performance && performance.now && performance.now() * 1000) || 0; //Time in microseconds since page-load or 0 if unsupported
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
            /[xy]/g,
            function (c) {
                var r = Math.random() * 16; //random number between 0 and 16
                if (d > 0) {
                    //Use timestamp until depleted
                    r = (d + r) % 16 | 0;
                    d = Math.floor(d / 16);
                } else {
                    //Use microseconds since page-load if supported
                    r = (d2 + r) % 16 | 0;
                    d2 = Math.floor(d2 / 16);
                }
                return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
            }
        );
    }

    public static removeByKey = function (arr, key, keyField) {
        for (var i = 0; i < arr.length; i++) {
            if (arr[i][keyField] == key) {
                arr.splice(i, 1);
                return arr;
            }
        }
        return null;
    };

    public static filterByKey = function (arr, key, keyField) {
        var res = [];
        for (var i = 0; i < arr.length; i++) {
            if (arr[i][keyField] == key) {
                res.push(arr[i]);
            }
        }
        return res;
    };

    public static filterByKeyTarget(arr, key, keyField, targetField) {
        var res = [];
        for (var i = 0; i < arr.length; i++) {
            if (arr[i][keyField] == key) {
                res.push(arr[i][targetField]);
            }
        }
        return res;
    }

    public static findKeyNdx(arr, key, keyField) {
        for (var i = 0; i < arr.length; i++) {
            if (arr[i][keyField] == key) {
                return i;
            }
        }
        return -1;
    }

    public static getParameterByName(name, url = null) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }

    public static addDays(date: Date, days: number): Date {
        date.setDate(date.getDate() + days);
        return date;
    }

    public static formatDate(dt: Date): string {
        return (
            dt.getFullYear() +
            '.' +
            ('0' + (dt.getMonth() + 1)).slice(-2) +
            '.' +
            ('0' + dt.getDate()).slice(-2)
        );
    }

    public static groupBy(xs, key) {
        return xs.reduce(function (rv, x) {
            (rv[x[key]] = rv[x[key]] || []).push(x);
            return rv;
        }, {});
    }
    
    public static ConvertToBase64(text: string){
        return btoa(encodeURIComponent(text).replace(/%([0-9A-F]{2})/g,
            function toSolidBytes(match, p1) {
                return String.fromCharCode(Number('0x' + p1));
            }))
            .replace("/", "-")
            .replace("+", "_");
    }
}
